import formatCount from '@/module/util/format-count'
import { mapActions, mapGetters, mapState } from 'vuex'


export default {

	props: {
		question: {
			type: Object,
			required: true
		}
	},

	watch: {
		keyList: {
			immediate: true,
			handler(newKeyList) {
				Object.keys(this.checkValues).forEach((key) => {
					if(newKeyList.includes(key))
						this.checkValues[key] = true
					else
						this.checkValues[key] = false
				})
			}
		}
	},

	data() {
		return {
			color: ['#c4c4ff', '#9fede6', '#ffbab1', '#c3f0c0', '#eeb1ff', '#bddcff'],
			showEventIndex: null,
			checkValues: this.question.answer.reduce((acc, { key }) => ({...acc, [key]: false}), {})
		}
	},

	methods: {
		...mapActions('outcome', [
			'setPatientList',
			'removePatientList'
		]),
		formatCount,
		/**
		 * Emits the list of patients is the response being clicked
		 *
		 * @param {[Object]} patientList
		 * @param {Event} event
		 */
		emitPatientList(patientList, event) {
			this.$emit('set-patient', patientList)
			event.stopPropagation()
		},
		/**
		 * Toggle filter to show only event responses on certain index
		 *
		 * @param {Number} index
		 * @param {Event} event
		 */
		toggleFilter(index, event) {
			if(this.showEventIndex === index)
				this.showEventIndex = null
			else
				this.showEventIndex = index
			event.stopPropagation()
		},
		/**
		 * Removes filter and show all event responses
		 *
		 */
		removeFilter() {
			this.showEventIndex = null
		},
		checkFilterCondition(index) {
			if(this.showEventIndex === null)
				return true
			else if (this.showEventIndex === index) {
				return true
			}
			return false
		},
		openPatientList(user, questionId, key, toggle) {
			if(toggle) {
				this.removePatientList()
			}
			if(this.keyList.includes(key))
				this.removePatientList(key)
			else
				this.setPatientList({
					user,
					questionId,
					key
				})
			return false
		}
	},
	computed: {
		...mapGetters('content', ['getContent']),
		...mapState('outcome', ['userListObj']),
		/**
		 * List of event object from the list of event ids
		 *
		 * @returns
		 */
		events() {
			//console.log(this.question.event)
			if (this.question.event) 
				return Object.keys(this.question.event).map(event => {
					return event == 'other' ? {name : 'other' } : this.getContent('event', event)
				})
			return []
		},
		keyList() {
			if(this.userListObj && this.userListObj.questionId == this.question.id)
				return this.userListObj.keyUserList.map(({key}) => key)
			return []
		}
	}
}
